import * as React from "react";
import _ from "lodash";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../../components/BaseListComponent";
import {
  createFilterData,
  mapEntityList,
} from "./../../../services/utility/autoMapperService";
import BaseListComponent from "./../../../components/BaseListComponent";
import bvnGreyListService from "../../../services/mandate/bvnGreyListService";
import ItemsTable, {
  filterFieldData,
} from "../../../components/tableComponents/itemsTable";
import TableFilterPane from "./../../../components/tableComponents/tableFilterPane";
import { getCurrentUsersRoles } from "../../../services/auth/authService";
import institutionsService from "../../../services/auth/institutionsService";
import BVNGreyListDetail from "./bvnGreyListDetail";
import AuditTrailDetail from "../../auditTrail/auditTrailDetail";

export interface BVNGreyListAppzoneProps {}

export interface BVNGreyListAppzoneState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
  updateBaseListState: boolean;
  toUpdate: boolean;
}

class BVNGreyListAppzoneList extends BaseListComponent<BVNGreyListAppzoneState> {}

class BVNGreyListAppzone extends React.Component<BVNGreyListAppzoneProps, BVNGreyListAppzoneState> {
  constructor(props: BVNGreyListAppzoneProps) {
    super(props);
    this.state = {
      data: createFilterData(["bvn", "institution", "status"]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [
        { name: "bvn", fieldType: "number", value: "" },
        {
          name: "institution",
          fieldType: "select",
          options: [],
          value: "",
        },
        {
          name: "status",
          fieldType: "select",
          options: ["Active", "Inactive"],
          value: "",
        },
      ],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
      updateBaseListState: false,
      toUpdate: true,
    };
  }

  handlePageChange = async (currentPage: number, pageSize:number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    this.setState({ fetching: true, updateBaseListState: false });
    let dataClone =
      typeof data === "undefined" ? { ...this.state.data } : { ...data };
    try {
      const institutions = await institutionsService.retrieveAllInstitutions();
      if (currentPage === 1 && this.state.toUpdate === true) {
        const institutionNames = !_.isEmpty(institutions)
          ? institutions.data.map((item) => item.name)
          : [];
        let filterValueInput = [...this.state.filterValueInput];
        // console.log("got institutions pre", filterValueInput);
        filterValueInput = filterValueInput.map((filterField) =>
          filterField.name === "institution"
            ? { ...filterField, options: institutionNames }
            : filterField
        );
        // console.log("got institutions", filterValueInput);
        this.setState({
          filterValueInput: filterValueInput,
          updateBaseListState: true,
          toUpdate: false,
        });
      }
      const institutionObj = !_.isEmpty(institutions)
        ? institutions.data.map((item) => {
            return { name: item.name, id: item.id };
          })
        : [];

      const selectedInstitutionObj = !_.isEmpty(institutionObj)
        ? institutionObj.filter(
            (item) => item.name === dataClone["institution"].item2
          )[0]
        : {};
      // console.log(selectedInstitutionObj);

      //fix to get correct branchId
      const newDataArray = ["bvn", "institutionId", "status"];
      let filterData = {};
      newDataArray.forEach((header) => {
        if (header === "institutionId") {
          filterData[header] = !_.isEmpty(selectedInstitutionObj)
            ? {
                item1: dataClone["institution"].item1,
                item2: selectedInstitutionObj.id,
              }
            : { item1: "like", item2: "" };
        } else {
          filterData[header] = dataClone[header];
        }
        // console.log("header into filter", filterData);
      });
      //   console.log("checkin issues", filterData);
      const BVNGreyList = await bvnGreyListService.filterBVNGreyLists(
        filterData,
        pageSize,
        currentPage,
        true
      );
      this.setState({
        tableItems: mapEntityList({
          entityList: BVNGreyList.data.item2,
          properties: [
            { oldName: "bvn", newName: "BVN" },
            { oldName: "institutionName", newName: "institutionName" },
            { oldName: "customerName", newName: "customerName" },
            { oldName: "customerPhoneNumber", newName: "customerPhoneNumber" },
          ],
        }),
        currentPage,
        pageSize,
        totalSize: BVNGreyList.data.item1,
        fetching: false,
      });
    } catch (ex) {
      // console.log("caught exception", ex);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        // this.setState({ errors, fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        // this.setState({ errors, fetching: false });
      }
    }
  };

  handleOnExport = async (type: string) => {};

  fetchItemById = async (item: any) => {
    this.setState({ fetchingDetail: true, updateBaseListState: false });
    // console.log("fetching detail with id: ", item.id);
    const greyListedBVN = await bvnGreyListService.retrieveBVNGreyListById(
      item.id
    );
    // console.log("branch: ", branch.data);
    this.setState({ item: greyListedBVN.data, fetchingDetail: false });
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }

  render() {
    const {
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    // console.log("asfsdf", this.state.filterValueInput);
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>BVN Grey-List</b>
              </h3>
            </div>
            <BVNGreyListAppzoneList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              updateState={this.state.updateBaseListState}
              initialValues={{
                data: createFilterData([
                  "bvn",
                  "institution",
                  "status",
                ]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: this.state.filterValueInput,
                item: {},
                jsonBefore: {},
                jsonAfter: {},
                fetchingTrail: false,
                entityName: "Recova.Mandate.BVNGreyList",
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                onToggleEditModal,
                showDetailsModal,
                showEditModal,
                fetchTrailItem,
                fetchingTrail,
                jsonAfter,
                jsonBefore,
                onToggleTrailModal,
                showTrailModal,
                trailItem,
                trailMapper,
              }) => (
                <Fragment>
                  <BVNGreyListDetail
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    toggleEditModal={onToggleEditModal}
                    showTrail={() => onToggleTrailModal(item)}
                    currentUserRoles={getCurrentUsersRoles()}
                    item={item}
                  />
                  <AuditTrailDetail
                    showDetailsModal={showTrailModal}
                    toggleDetailsModal={onToggleTrailModal}
                    fetchNextTrail={fetchTrailItem}
                    item={trailItem}
                    trailMapper={trailMapper}
                    fetchingDetail={fetchingTrail}
                    jsonBefore={jsonBefore}
                    jsonAfter={jsonAfter}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="BVNGreyList"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></BVNGreyListAppzoneList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default BVNGreyListAppzone;
